import styled, { css } from "styled-components/native";
import { light_black, spacing_l, spacing_s, white } from "../../StyleHelpers";
import { Props } from "./model";

export const StyledStudioAccessBanner = styled.View<Props>`
	flex-direction: row;
	right: 0;
`;

export const StyledTextContainer = styled.View<Props>`
	padding: 0 0 0 ${spacing_l};
	width: 40vw;
	height: 40vh;
	z-index: 9;
	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			width: 602.714px;
			gap: 10px;
		`}
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const StyledText = styled.Text<{ isNarrow: boolean }>`
	width: ${(props) => (props.isNarrow ? "35rem" : "20vw")};
	height: 10vh;
	color: ${white};
	font-size: 1.8rem;
	margin-bottom: ${spacing_s};

	${(props) =>
		props.isNarrow &&
		css`
			font-size: 21px;
			font-weight: 500;
			line-height: 25px;
		`}
`;

export const StyledImage = styled.View<Props>`
	height: 100%;
	background-image: linear-gradient(to left, transparent, ${light_black});
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;

	${(props) =>
		props.banner &&
		css`
			background-image: url(${props.banner});
			background-position: top;
			background-repeat: no-repeat;
			background-size: cover;
			top: 80px;
		`}

	${(props) =>
		!props.banner &&
		css`
			background-color: ${white};
		`}
`;

//Narrow Screen
export const StyledControllerLoader = styled.View`
	position: fixed;
	height: calc(100vh - 80px);
	width: 300px;
	top: 80px;
	left: 80px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
`;

export const StyledMainContainer = styled.View<Props>`
	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			flex-direction: row;
			position: relative;
		`}
	overflow: hidden;
`;

export const StyledMainStudioAccessPlaylistContainer = styled.View<Props>`
	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			width: calc(100% - 380px);
			left: 380px;
			overflow: hidden;
		`}

	${(props) =>
		!props.isToggleMQTT &&
		css`
			width: calc(100% - 80px);
			left: 80px;
		`}
`;
